module.exports = __webpack_public_path__ + "static/assets/2e53c82709fcc0d493c0384eea89b2cc.svg";